import { call, put } from "redux-saga/effects";
import {
  addNewNonSaleableReturn,
  editNonSaleableReturn,
  deleteNonSaleableReturn,
} from "../../app/components/InventoryManagement/NonSaleableReturn/helper/nonSaleableReturnHelper";
import {
  addNewNonSaleableReturnSuccessAction,
  editNonSaleableReturnSuccessAction,
  deleteNonSaleableReturnSuccessAction,
} from "./actions";

export function* addNewNonSaleableReturnSaga(payload) {
  try {
    const response = yield call(
      addNewNonSaleableReturn,
      payload.nonSaleableReturnData
    );
    yield put(addNewNonSaleableReturnSuccessAction(response.data));
  } catch (err) {}
}

export function* editNonSaleableReturnSaga(payload) {
  try {
    const response = yield call(
      editNonSaleableReturn,
      payload.nonSaleableReturnData
    );
    yield put(editNonSaleableReturnSuccessAction(response.data));
  } catch (err) {}
}

export function* deleteNonSaleableReturnSaga(payload) {
  try {
    const response = yield call(
      deleteNonSaleableReturn,
      payload.nonSaleableReturnData
    );
    yield put(deleteNonSaleableReturnSuccessAction(response.data));
  } catch (err) {}
}
